
export const checkUserPermissions = (userPermissions: any[], requestedPermissionCode: string) => {
    return userPermissions?.some((permission) => permission.code === requestedPermissionCode)
}